import { AxiosPromise, AxiosRequestConfig } from 'axios';
import { urlConfig, config } from 'lib/config';
import { ENV } from 'lib/constants/domain';
import { getLoginType } from 'lib/utils/util';
import channelService from 'lib/services/channelService';
import msdkUtil from '../MSDK';
import session from '../session';
import HttpRequest from './request';

class BenefitNetwork {
  private httpRequest: HttpRequest;

  constructor() {
    this.httpRequest = new HttpRequest({
      baseUrl: urlConfig.benefitUrl,
    });
  }

  public request(options: AxiosRequestConfig = {}): AxiosPromise<any> | undefined {
    // 与 network.request 一致：在 NewFlowInit 写入 channelService.gameCode 之前，
    // serviceType Header 会是 undefined，直接放弃发送，避免发出脏请求
    if (!channelService.gameCode) return;
    if (msdkUtil.isMSDK) {
      return this.requestMSDK(options);
    }
    return this.requestNoMSDK(options);
  }

  private requestMSDK(options: AxiosRequestConfig): AxiosPromise<any> {
    return this.httpRequest.request({
      ...options,
      params: {
        ...msdkUtil.MSDKParams,
        ...this.getGrayParams(),
        ...(options.params || {}),
      },
      data: {
        ...(options.data || {}),
        msdkVersion: msdkUtil.MSDKVersion,
      },
      headers: this.buildHeaders(options.headers),
    });
  }

  private requestNoMSDK(options: AxiosRequestConfig): AxiosPromise<any> {
    return this.httpRequest.request({
      ...options,
      params: {
        ...this.getGrayParams(),
        ...(options.params || {}),
      },
      headers: this.buildHeaders(options.headers),
    });
  }

  private buildHeaders(extra?: AxiosRequestConfig['headers']) {
    const { token } = session.getSessionData();
    return {
      loginType: getLoginType(),
      serviceType: channelService.gameCode,
      ...(token ? { Authorization: token } : {}),
      ...(extra || {}),
    };
  }

  private getGrayParams() {
    return config.env === ENV.GRAY ? { canaryclient: ENV.GRAY } : {};
  }
}

const benefitNetwork = new BenefitNetwork();

export default benefitNetwork;
